import { createRoute, dynamicWrapper } from "@/utils/core";

const routesConfig = (app) => ({
  path: "/account/login",
  title: "Login",
  component: dynamicWrapper(app, [], () => import("./components")),
});

export default (app) => createRoute(app, routesConfig);
